import { forwardRef } from "react";

const FileInput = forwardRef(function FileInput({
  label,
  handleFileChange,
  acceptFormat,
  required,
  id,
  name,
  imageURL,
  errorMessage,
  disabled,
  ref,
  multiple = false,
  onClearImage,
}) {
  return (
    <>
      <div className={`${imageURL ? "w-80" : "w-100"}`}>
        <label className="form-label col-form-label  w-100 fs-5 form-label-custom-visible p-0">
          {label} {required && <span className="text-danger">*</span>}
        </label>
        <div>
          <input
            ref={ref}
            className={`form-control fs-5 ${
              errorMessage && errorMessage?.[name]?.trim()?.length > 0
                ? "input-error"
                : ""
            }`}
            type="file"
            id={id}
            name={name}
            accept={acceptFormat}
            onChange={handleFileChange}
            // required={required}
            disabled={disabled}
            multiple={multiple}
          />
        </div>
        {errorMessage &&
          errorMessage[name] &&
          Object?.keys(errorMessage).length > 0 && (
            <div className="text-danger fw-700 fs-6 mt-1">
              {/* {errorMessage && errorMessage[name + "-size"]
            ? errorMessage[name + "-size"]
            : ""}
          {errorMessage && errorMessage[name + "-type"]
            ? errorMessage[name + "-type"]
            : ""} */}
              {errorMessage && errorMessage[name] ? errorMessage[name] : ""}
            </div>
          )}
      </div>
      {imageURL && (
        <div className="col-md-3 p-2 position-relative">
          <img
            height={"80px"}
            width={"80px"}
            src={imageURL}
            alt=""
            // onClick={isZoom ? handleZoom : undefined}
          />
          {onClearImage && (
            <button
              type="button"
              className="btn btn-danger btn-sm p-0 d-flex align-items-center justify-content-center position-absolute top-0 end-0 l-75"
              style={{
                width: "20px",
                height: "20px",
                fontSize: "12px",
              }}
              onClick={onClearImage}
            >
              ✕
            </button>
          )}
        </div>
      )}
    </>
  );
});

export default FileInput;
